export const strings = {
    SUCCESS_UPDATE: 'Изменения сохранены',
    btnSave: 'Сохранить',
    btnCreate: 'Создать',
    btnAdd: 'Добавить',
    btnOk: 'Подтвердить',
    btnApply: 'Применить',
    btnCancel: 'Отменить',
    btnDelete: 'Удалить',
    taskToday: 'Задачи на сегодня',
    autoSet: 'A',
    export: 'Выгрузить',
    btnActivate: 'Активировать',
    btnDeactivate: 'Деактивировать',
};
